(function () {
  var observer = null;
  var trackedVideos = new Set();
  var videoStates = new WeakMap();
  var replayButtons = new WeakMap();
  var pauseButtons = new WeakMap();
  var sectionVideoMap = new WeakMap();
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function getState(video) {
    var state = videoStates.get(video);
    if (!state) {
      state = {
        ended: false,
        pausedByUser: false,
        startedOnce: false,
        inView: false,
        programmaticPause: false
      };
      videoStates.set(video, state);
    }
    return state;
  }

  function hasEnded(video) {
    return getState(video).ended;
  }

  function setEnded(video, ended) {
    var state = getState(video);
    state.ended = ended;
  }

  function pauseVideo(video) {
    if (!video || video.paused) return;
    var state = getState(video);
    state.programmaticPause = true;
    video.pause();
    setTimeout(function () {
      state.programmaticPause = false;
    }, 0);
  }

  function playVideo(video) {
    if (!video || prefersReducedMotion) return;
    var promise = video.play();
    if (promise && typeof promise.catch === 'function') {
      promise.catch(function () {
        // Autoplay can be blocked; no-op to avoid console noise.
      });
    }
  }

  function onIntersect(entries) {
    entries.forEach(function (entry) {
      var section = entry.target;
      var video = sectionVideoMap.get(section);
      if (!video) return;
      var state = getState(video);
      var isVisible = entry.isIntersecting && entry.intersectionRatio > 0;
      var meetsFirstPlayThreshold = entry.isIntersecting && entry.intersectionRatio >= 0.3;
      var canAutoplay = state.startedOnce ? isVisible : meetsFirstPlayThreshold;
      state.inView = isVisible;

      if (canAutoplay) {
        if ((!hasEnded(video) || video.currentTime === 0) && !state.pausedByUser) {
          playVideo(video);
        }
      } else if (!isVisible) {
        state.pausedByUser = false;
        pauseVideo(video);

        var replayButton = replayButtons.get(video);
        if (replayButton) {
          replayButton.hidden = video.currentTime === 0 && !video.ended;
        }

        var pauseButton = pauseButtons.get(video);
        if (pauseButton) {
          pauseButton.hidden = true;
        }
      } else {
        pauseVideo(video);
        var warmupPauseButton = pauseButtons.get(video);
        if (warmupPauseButton) {
          warmupPauseButton.hidden = true;
        }
      }
    });
  }

  function ensureObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(onIntersect, {
      root: null,
      threshold: [0, 0.01, 0.3]
    });
    return observer;
  }

  function initSection(section) {
    if (!section) return;
    var videos = section.querySelectorAll('[data-maxcalm26-bg-video]');
    if (!videos.length) return;

    var io = ensureObserver();
    videos.forEach(function (video) {
      if (trackedVideos.has(video)) return;
      setEnded(video, false);
      getState(video).pausedByUser = false;
      var replayButton = video.parentElement
        ? video.parentElement.querySelector('[data-maxcalm26-video-replay]')
        : null;
      var pauseButton = video.parentElement
        ? video.parentElement.querySelector('[data-maxcalm26-video-pause]')
        : null;
      replayButtons.set(video, replayButton);
      pauseButtons.set(video, pauseButton);

      function hideReplayButton() {
        if (!replayButton) return;
        replayButton.hidden = true;
      }

      function showReplayButton() {
        if (!replayButton) return;
        replayButton.hidden = false;
      }

      function hidePauseButton() {
        if (!pauseButton) return;
        pauseButton.hidden = true;
      }

      function showPauseButton() {
        if (!pauseButton) return;
        pauseButton.hidden = false;
      }

      video.muted = true;
      video.setAttribute('muted', 'muted');
      video.playsInline = true;
      video.setAttribute('playsinline', 'playsinline');
      video.removeAttribute('controls');

      video.addEventListener('play', function () {
        var state = getState(video);
        setEnded(video, false);
        state.startedOnce = true;
        state.pausedByUser = false;
        hideReplayButton();
        showPauseButton();
      });

      video.addEventListener('ended', function () {
        setEnded(video, true);
        hidePauseButton();
        showReplayButton();
      });

      video.addEventListener('pause', function () {
        var state = getState(video);
        hidePauseButton();
        if (state.programmaticPause || video.ended || !state.inView) return;
        state.pausedByUser = true;
        showReplayButton();
      });

      if (replayButton) {
        replayButton.addEventListener('click', function () {
          var state = getState(video);
          setEnded(video, false);
          state.pausedByUser = false;
          video.currentTime = 0;
          hideReplayButton();
          playVideo(video);
        });
      }

      if (pauseButton) {
        pauseButton.addEventListener('click', function () {
          if (video.paused || video.ended) return;
          video.pause();
        });
      }

      sectionVideoMap.set(section, video);
      io.observe(section);
      trackedVideos.add(video);
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('[data-maxcalm26-video-icon-grid]');
    sections.forEach(initSection);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) return;
    trackedVideos.forEach(function (video) {
      pauseVideo(video);
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target);
  });
})();
